module.exports = __webpack_public_path__ + "static/media/logo-arter.95e127d5.svg";